var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/css/reset.css": "4ee2",
	"./assets/images/day_cloud.png": "dd31",
	"./assets/images/logo-dark.png": "59da",
	"./assets/images/logo.png": "9d64",
	"./assets/images/night_star.png": "0271",
	"./assets/images/qrcode/badatong-mobile.png": "ea6c",
	"./assets/images/qrcode/bdtApk.png": "9683",
	"./assets/images/qrcode/bdtoil-mobile.png": "8aee",
	"./assets/images/qrcode/bdtoilApk.png": "24db",
	"./assets/images/qrcode/jxq-mobile.png": "db3c",
	"./assets/images/qrcode/jxqApk.png": "4014",
	"./assets/images/qrcode/oil-mobile.png": "4c2a",
	"./assets/images/qrcode/oilApk.png": "75ea",
	"./assets/images/qrcode/qz-mobile.png": "3f3b",
	"./assets/images/qrcode/qzApk.png": "ceb3",
	"./components/Books": "7b6b",
	"./components/Books.vue": "7b6b",
	"./components/Footer": "fd2d",
	"./components/Footer.vue": "fd2d",
	"./components/Menu": "fb62",
	"./components/Menu.vue": "fb62",
	"./components/copyright-icp": "7935",
	"./components/copyright-icp.vue": "7935",
	"./main": "56d7",
	"./main.js": "56d7",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./store": "4360",
	"./store/": "4360",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./views/Index": "d504",
	"./views/Index.vue": "d504",
	"./views/download": "565b",
	"./views/download.vue": "565b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";